import { useTranslation } from "react-i18next";
import { IconButton } from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { useInboxContext } from "context/InboxProvider";
import { useDropdownMenu } from "hooks/useDropdownMenu";
import MenuDropdown from "../../../menu-dropdown/MenuDropdown";
import { ReactComponent as ReadOneIcon } from "assets/icons/check.svg";
import { ReactComponent as DeleteOneIcon } from "assets/icons/medium.svg";

const NotificationDropdown = ({ id }) => {
  const { t } = useTranslation();
  const { isOpen, anchorEl, open, close } = useDropdownMenu();

  const { readOne, deleteOne } = useInboxContext();

  const handleRead = () => {
    readOne(id);
  };

  const handleDelete = () => {
    deleteOne(id);
  };

  const items = [
    {
      label: t("Inbox.Dropdown.Read", { count: 1 }),
      iconComponent: <ReadOneIcon width={20} height={20} />,
      onClick: handleRead,
    },
    {
      label: t("Inbox.Dropdown.Delete"),
      iconComponent: <DeleteOneIcon width={20} height={20} />,
      onClick: handleDelete,
    },
  ];

  return (
    <MenuDropdown
      items={items}
      isOpen={isOpen}
      anchorEl={anchorEl}
      onClose={close}
      onOpen={open}
      placement="bottom-end"
    >
      <IconButton size="small">
        <MoreHorizIcon />
      </IconButton>
    </MenuDropdown>
  );
};

export default NotificationDropdown;
